module.exports = __webpack_public_path__ + "static/media/bg-valuation.5a66e183.png";